import ReporteDivisa from '@pages/operadora-loteria/reporte/divisa';
import ReporteFigura from '@pages/operadora-loteria/reporte/figura';
import ReporteGeneral from '@pages/operadora-loteria/reporte/general';
import CupoNumero from '@pages/operadora-loteria/cupo-numero';

export default [
    {
        path: '/loteria/administracion/cupo-numero',
        name: 'operadora-loteria.administracion.cupo',
        component: CupoNumero,
    },
    {
        path: '/loteria/reporte/general',
        name: 'operadora-loteria.reporte.general',
        component: ReporteGeneral,
    },
    {
        path: '/loteria/reporte/figura',
        name: 'operadora-loteria.reporte.figura',
        component: ReporteFigura,
    },
    {
        path: '/loteria/reporte/divisa',
        name: 'operadora-loteria.reporte.consolidado.divisa',
        component: ReporteDivisa,
    },
];
